// extracted by mini-css-extract-plugin
export default {"AllFAQ":"Faq_AllFAQ__CaiCq","Title":"Faq_Title__Z57YX","Item":"Faq_Item__MZXYV","ShowIcon":"Faq_ShowIcon__i8RGa","SectionTitle":"Faq_SectionTitle__eZVoP"};